/**
 * @generated SignedSource<<50b737c4b5a31ce0f1965e3722dd7384>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnreadThreadPayload",
    "kind": "LinkedField",
    "name": "unreadThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationHistoryQuery_unreadThreadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConversationHistoryQuery_unreadThreadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "784281c3e3bd04507893b388400bbba4",
    "id": null,
    "metadata": {},
    "name": "ConversationHistoryQuery_unreadThreadMutation",
    "operationKind": "mutation",
    "text": "mutation ConversationHistoryQuery_unreadThreadMutation(\n  $input: UnreadThreadInput!\n) {\n  unreadThread(input: $input) {\n    clientMutationId\n    ok\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "455f4489131c0be51179c542d5026ff9";

module.exports = node;
